import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CreateTenderStageMutationRequest, CreateTenderStageMutationResponse, CreateTenderStageQueryParams } from "../../types/CreateTenderStage";

/**
     * @link /api/purchase-tenders/private/v1/stage
     */
export async function createTenderStage (data: CreateTenderStageMutationRequest, params: CreateTenderStageQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<CreateTenderStageMutationResponse>["data"]> {
    const { data: resData } = await client<CreateTenderStageMutationResponse, CreateTenderStageMutationRequest>({
        method: "post",
        url: `/api/purchase-tenders/private/v1/stage`,
        params,
        data,
        ...options
    });
    
    return resData;
};